import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { PanelKey_Findings } from '../../../_shared.js';
import './AdvisorPanel_Findings.scss';
import { ICONS } from '@app/styles';
import { ModuleFE_Spotlight } from '../../../modules/ModuleFE_Spotlight/index.js';
import { ModuleFE_EMInterface, } from '@app/advisor-frontend';
import { Component_Findings } from '../../components/findings/Component_Findings/Component_Findings.js';
export class AdvisorPanel_Findings extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_Findings,
    };
    //######################### Life Cycle #########################
    __onPathwayEndUpdated() {
        if (!ModuleFE_EMInterface.isPostDisposition())
            return;
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve readonly mode into the state
        return state;
    }
    //######################### Logic #########################
    getPanelClass() {
        return _className(super.getPanelClass(), 'panel__findings', this.props.context === 'floating' && 'special-panel');
    }
    //######################### Render - Header #########################
    renderHeader_Title = () => 'Findings';
    renderHeader_Tail = () => {
        const readonly = ModuleFE_EMInterface.isReadonly();
        if (readonly)
            return;
        const postDisposition = ModuleFE_EMInterface.isPostDisposition();
        const className = _className(postDisposition && 'disabled');
        return _jsx(ICONS.advisor_avn_add.component, { className: className, onClick: () => {
                if (postDisposition)
                    return;
                ModuleFE_Spotlight.openEditFindings({ findings: { processedRawFindings: [], findingsToUpdate: [] } });
            } });
    };
    //######################### Render - Content #########################
    _renderContent = (scrollRef) => _jsx(Component_Findings, { scrollRef: scrollRef });
    renderContent = () => _jsx(_Fragment, {});
    //######################### Render - Footer #########################
    renderFooter = undefined;
    renderSubHeader = undefined;
}
//# sourceMappingURL=AdvisorPanel_Findings.js.map